module.exports = __webpack_public_path__ + "img/check.0365aae0.svg";